module.exports = __webpack_public_path__ + "img/wximg12.a0b528e4.png";